import { create } from "zustand";

interface MainStoreType {
  autoTagList: string[];
  updateAutoTagList: (list: string[]) => void;
  identifierMap: Record<string, string[]>;
  updateIdentifierMap: (map: Record<string, string[]>) => void;
}

const useMainStore = create<MainStoreType>((set) => ({
  autoTagList: [],
  updateAutoTagList: (list: string[]) => set({ autoTagList: list }),
  identifierMap: {},
  updateIdentifierMap: (map: Record<string, string[]>) => set({ identifierMap: map }),
}));

export default useMainStore;
